import * as React from 'react';
import { RouteComponentProps } from 'react-router';

export class Home extends React.Component<RouteComponentProps<{}>, {}> {
    public render() {
        return <div>
            <h1>Welcome!</h1>
            <p>This is the Coherent PDF API Server. Here you can:</p>
            <ul>
                <li>User can fill Uploaded PDF files with specified Json Data.</li>
                <li>User can fill PDF files with predefined uploaded templates</li>
                <li>User can fill PDF files using doc store file path</li>
                <li>User can merge PDFs files, by specified multiple pdf files and data throguh api</li>
                <li>User can get  Zip PDFs files, by specified multiple pdf files and data throguh api</li>
            </ul>
            <p>To help you get started, You can use <a href="swagger/index.html">swagger</a> for PDF Service API</p>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/Home.tsx